<mat-form-field class="no-bottom manufacturer">
  <mat-label>{{ label }}</mat-label>
  <input #manufacturerInput
         (focus)="filter()"
         (input)="filter()"
         [formControl]="control"
         [matAutocomplete]="manufacturerAuto"
         [placeholder]="placeholder"
         matInput type="text">
</mat-form-field>
<mat-autocomplete #manufacturerAuto="matAutocomplete" (optionSelected)="onOptionSelected($event)"
                  class="manufacturer-autocomplete" panelWidth="240px" requireSelection>
  @for (mfr of filteredManufacturers; track mfr.name) {
    <mat-option [value]="mfr.name">
      <span [innerHtml]="highlight(mfr.name, manufacturerInput.value)" class="manufacturer"></span>
    </mat-option>
  }
  <mat-option *ngIf="showCreateOption()" [value]="trim(manufacturerInput.value)" id="create">
    <mat-icon class="yellow small-icon">warning</mat-icon>
    <span class="manufacturer">Create new manufacturer "{{ manufacturerInput.value }}"</span>
  </mat-option>
</mat-autocomplete>
